function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartScaleSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M1107.436,555.198c-96.454,140.604,16.64,368.558-126.481,474.304 c-139.318,102.936-310.466-65.79-441.764,22.817c-194.773,131.443-159.204,732.9,125.565,1106.598 c85.64,112.384,157.197,156.111,188.89,283.211c68.052,272.917-171.119,435.265-125.604,570.246 C830.521,3316.301,2406.604,3571.331,3039,2657.931c295.354-426.596,339.545-1042.603,75.656-1510.464 C2637.81,302.05,1323.863,239.708,1107.436,555.198z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DDE3"
    },
    d: "M1688.078,2969.452c64.577-5.085,173.292-13.646,268.281-91.745 c172.691-141.99,187.907-421.656,132.139-614.172c-47.901-165.362-175.993-294.426-432.174-552.557 c-241.271-243.11-332.75-285.295-332.211-400.747c0.769-164.59,187.47-245.383,159.82-437.414 c-3.319-23.043-14.714-102.189-74.628-144.398c-102.561-72.256-275.315,14.432-363.353,87.178 c-84.92,70.169-190.656,209.694-165.366,347.241c18.323,99.656,89.86,113.613,86.215,200.694 c-3.668,87.615-77.191,99.913-139.383,231.55c-24.847,52.589-74.719,158.151-47.57,264.644 c35.105,137.697,167.204,152.303,167.7,260.395c0.358,78.1-68.491,96.01-86.351,182.354 c-23.513,113.67,67.161,221.13,143.806,309.533C1095.256,2716.107,1338.747,2996.957,1688.078,2969.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M1355.283,766.841c50.09,58.388-174.731,204.131-188.994,468.518 c-15.346,284.468,222.429,532.746,332.312,647.482c187.478,195.76,289.822,190.506,393.402,383.629 c40.996,76.434,126.403,235.671,67.618,411.415c-5.462,16.329-69.04,197.46-232.916,249.054 c-185.879,58.523-359.469-94.112-509.047-225.626c-90.381-79.469-270.931-238.217-226.341-350.689 c27.258-68.755,132.373-104.385,210.863-102.42c112.027,2.8,185.16,82.563,199.445,66.424 c12.867-14.535-34.088-93.23-108.532-161.649c-148.903-136.851-255.55-92.672-361.69-211.737 c-12.866-14.431-113.152-130.279-82.649-260.158c17.591-74.908,79.148-156.431,142.683-156.419 c71.858,0.013,115.234,104.315,134.625,93.688c18.542-10.161-9.852-111.695-52.464-207.853 c-62.611-141.288-103.747-153.238-119.069-236.491c-23.377-127.018,47.302-235.448,57.683-250.89 C1109.489,778.428,1312.457,716.921,1355.283,766.841z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFC6D1"
    },
    d: "M1504.488,2916.497c36.575-23.198,98.147-62.253,129.94-138.103 c57.8-137.899-20.35-307.901-113.29-404.211c-79.831-82.727-195.736-118.93-427.546-191.339 c-218.319-68.195-285.519-64.515-321.174-132.899c-50.831-97.49,34.317-203.611-41.857-308.429 c-9.141-12.577-40.536-55.777-89.091-61.982c-83.118-10.622-158.188,94.622-187.542,165.134 c-28.316,68.015-47.32,183.52,10.482,256.882c41.88,53.153,88.5,39.028,113.48,91.622c25.133,52.915-14.481,83.173-10.213,180.4 c1.705,38.843,5.127,116.811,54.352,171.243c63.649,70.382,146.258,37.703,180.232,101.416 c24.547,46.033-10.556,78.146,5.795,134.748c21.525,74.516,108.588,109.655,181.424,137.922 C1075.247,2952.188,1306.638,3041.988,1504.488,2916.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M621.519,1719.131c47.792,18.835-39.644,175.253,34.31,335.928 c79.57,172.88,297.433,245.223,398.115,278.654c171.778,57.041,230.617,21.932,351.998,103.65 c48.041,32.341,148.125,99.721,168.15,221.944c1.861,11.355,20.731,138.26-60.027,219.991 c-91.601,92.705-241.736,56.803-371.1,25.87c-78.168-18.692-234.321-56.03-243.018-136.428 c-5.317-49.148,45.694-103.071,92.686-126.455c67.07-33.378,135.138-9.118,138.551-23.121 c3.074-12.612-49.193-44.426-114.501-61.573c-130.629-34.296-179.882,25.157-279.7-12.002 c-12.099-4.503-107.456-41.593-129.901-127.873c-12.946-49.76-1.974-117.179,35.573-137.04 c42.465-22.463,100.596,25.6,108.743,13.258c7.791-11.802-40.624-62.916-95.766-106.406 c-81.022-63.902-109.052-58.1-144.048-102.499c-53.391-67.74-45.413-153.909-44.09-166.279 C479.89,1802.84,580.659,1703.028,621.519,1719.131z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1732.3502,
    y1: 2734.7754,
    x2: 1652.7137,
    y2: 2458.3909
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5554,
    style: {
      stopColor: "#6F2B60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    points: "1059.221,2580.171 1643.115,2554.784 2315.862,2578.357 1652.182,2723.424  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119821495271323328890000005104784079184773269_",
    gradientUnits: "userSpaceOnUse",
    x1: 1198.3651,
    y1: 3137.3149,
    x2: 1300.8022,
    y2: 2904.3203
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119821495271323328890000005104784079184773269_)"
    },
    d: "M1529.673,3142.829l-472.965-127.293 c-47.632-12.82-84.64-60.014-84.64-105.782v-0.503c0-45.767,37.007-76.474,84.64-68.072l507.278,83.013L1529.673,3142.829z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065794296636724420600000008508321515296991167_",
    gradientUnits: "userSpaceOnUse",
    x1: 1465.2445,
    y1: 3003.6689,
    x2: 2316.6729,
    y2: 3003.6689
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4F7FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#D8DEE8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065794296636724420600000008508321515296991167_)"
    },
    d: "M2316.673,3047.235l-764.211,85.344 c-47.865,5.345-87.218-28.033-87.218-74.629v-31.61c0-46.596,39.352-87.502,87.218-91.312l764.211-60.83 C2282.856,2937.151,2275.054,2996.047,2316.673,3047.235z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155830829670522477110000016910198286037043130_",
    gradientUnits: "userSpaceOnUse",
    x1: 1444.6978,
    y1: 3004.0718,
    x2: 2331.6465,
    y2: 3004.0718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155830829670522477110000016910198286037043130_)"
    },
    d: "M2323.324,3055.709l-764.458,86.679 c-62.432,7.079-114.168-36.65-114.168-97.61v-0.67c0-60.96,51.735-114.589,114.168-119.459l764.458-59.624 c4.6-0.359,8.323,3.471,8.323,8.554c0,5.083-3.723,9.506-8.323,9.88l-764.458,62.239c-50.226,4.089-91.696,47.298-91.696,96.26 v0.667c0,48.961,41.471,84.234,91.696,78.711l764.458-84.063c4.6-0.506,8.323,3.205,8.323,8.288 C2331.646,3050.646,2327.923,3055.188,2323.324,3055.709z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178910741914470287390000011647620533866021802_",
    gradientUnits: "userSpaceOnUse",
    x1: 983.1877,
    y1: 3250.1899,
    x2: 1224.4385,
    y2: 2849.6667
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5554,
    style: {
      stopColor: "#6F2B60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178910741914470287390000011647620533866021802_)"
    },
    d: "M1549.543,2924.706l-492.834-83.526 c-47.632-8.402-84.64-70.838-84.64-139.558v-0.755c0-68.721,37.007-123.254,84.64-121.485l522.8,19.42L1549.543,2924.706z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030480262597799834630000011076225609735846071_",
    gradientUnits: "userSpaceOnUse",
    x1: 1465.2445,
    y1: 2749.1746,
    x2: 2316.6729,
    y2: 2749.1746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F4F7FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#D8DEE8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030480262597799834630000011076225609735846071_)"
    },
    d: "M2316.673,2851.689l-721.381,54.411 c-71.146,5.366-130.047-46.909-130.047-116.873v-47.463c0-69.964,58.902-128.287,130.047-130.227l721.381-19.666 C2282.747,2686.204,2275.164,2774.536,2316.673,2851.689z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171712410689295297530000015851321097473014161_",
    gradientUnits: "userSpaceOnUse",
    x1: 1444.6978,
    y1: 2751.8008,
    x2: 2331.6465,
    y2: 2751.8008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5554,
    style: {
      stopColor: "#6F2B60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171712410689295297530000015851321097473014161_)"
    },
    d: "M2323.324,2865.027l-764.458,59.624 c-62.432,4.87-114.168-65.562-114.168-157.094v-1.006c0-91.532,51.735-167.284,114.168-168.836l764.458-18.999 c4.6-0.115,8.323,5.98,8.323,13.612s-3.723,13.93-8.323,14.068l-764.458,22.927c-50.226,1.506-91.696,62.559-91.696,136.075 v1.003c0,73.515,41.471,130.303,91.696,126.644l764.458-55.696c4.6-0.335,8.323,5.581,8.323,13.212 C2331.646,2858.191,2327.923,2864.668,2323.324,2865.027z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M1396.716,2855.835l-105.346-18.41c-24.599-67.143-22.75-128.821,0-202.538 l105.346,7.489C1375.124,2719.949,1378.393,2790.214,1396.716,2855.835z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163038873344699779670000005956954765641672597_",
    gradientUnits: "userSpaceOnUse",
    x1: 1503.9493,
    y1: 866.8226,
    x2: 1523.7319,
    y2: 1086.9027
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163038873344699779670000005956954765641672597_)"
    },
    d: "M1888.958,1113.626l-757.248,11.063 V972.392c0-43.327,60.765-68.869,89.191-39.806l15.849,34.506c26.316,26.905,63.516,34.89,96.377,20.881l555.831-236.959 V1113.626z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019650614128693159600000008612975147907177357_",
    gradientUnits: "userSpaceOnUse",
    x1: -3815.4861,
    y1: 863.4508,
    x2: -3795.8503,
    y2: 1081.8994,
    gradientTransform: "matrix(-1 0 0 1 -1516.4751 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019650614128693159600000008612975147907177357_)"
    },
    d: "M1962.733,1112.548l647.835-9.465 l25.229-134.438c0-37.344-59.545-54.001-81.11-28.892l-23.601,27.479c-20.378,23.727-49.513,30.969-75.574,18.633 l-492.777-233.24V1112.548z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050638480945192761700000009530508664492587442_",
    gradientUnits: "userSpaceOnUse",
    x1: 1529.8112,
    y1: 872.0877,
    x2: 1549.5938,
    y2: 1092.168
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050638480945192761700000009530508664492587442_)"
    },
    d: "M1914.82,1118.891l-757.248,11.063 V977.657c0-43.328,45.827-65.84,74.253-36.777l30.787,31.477c26.315,26.905,63.515,34.891,96.377,20.881l555.831-236.959 V1118.891z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048483099887698013860000018076323478353294229_",
    gradientUnits: "userSpaceOnUse",
    x1: -3834.8286,
    y1: 868.13,
    x2: -3815.1926,
    y2: 1086.5786,
    gradientTransform: "matrix(-1 0 0 1 -1516.4751 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048483099887698013860000018076323478353294229_)"
    },
    d: "M1988.594,1117.813l647.835-9.465 V977.084c0-37.344-34.317-57.174-55.882-32.066l-23.602,27.479c-20.378,23.727-49.513,30.969-75.574,18.633l-492.777-233.24 V1117.813z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153671863896426734140000014021857816929743510_",
    gradientUnits: "userSpaceOnUse",
    x1: 484.5231,
    y1: 1671.1487,
    x2: 1830.6304,
    y2: 1671.1487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000153671863896426734140000014021857816929743510_)"
    },
    points: "1824.927,2247.177  1157.568,1108.991 490.217,2241.646 484.523,2237.463 1157.581,1095.121 1160.426,1099.971 1830.63,2243.008  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023240106508660417190000002683654736937675157_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.6027,
    y1: 2323.0681,
    x2: 1850.5461,
    y2: 2323.0681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5554,
    style: {
      stopColor: "#6F2B60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023240106508660417190000002683654736937675157_)"
    },
    d: "M1850.546,2245.092 c0,50.852-310.254,248.026-692.972,248.026s-692.972-197.175-692.972-248.026c0-50.852,310.254-92.075,692.972-92.075 S1850.546,2194.241,1850.546,2245.092z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 1157.574,
    cy: 2241.579,
    rx: 692.972,
    ry: 92.075
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178900793807216219090000014388337147546970781_",
    gradientUnits: "userSpaceOnUse",
    x1: 1152.968,
    y1: 2182.0361,
    x2: 1163.177,
    y2: 2295.6106
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000178900793807216219090000014388337147546970781_)"
    },
    cx: 1157.574,
    cy: 2233.282,
    rx: 670.205,
    ry: 71.587
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026883310195786788330000008271107134942027424_",
    gradientUnits: "userSpaceOnUse",
    x1: 1150.5704,
    y1: 922.2883,
    x2: 1185.0646,
    y2: 1807.6266
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000026883310195786788330000008271107134942027424_)"
    },
    cx: 1157.574,
    cy: 1102.056,
    rx: 81.793,
    ry: 91.333
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054971792995950998050000013510178195077182596_",
    gradientUnits: "userSpaceOnUse",
    x1: 2048.8455,
    y1: 1587.2811,
    x2: 3224.0105,
    y2: 1587.2811
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000054971792995950998050000013510178195077182596_)"
    },
    points: "3219.031,2090.159  2636.42,1096.512 2053.816,2085.332 2048.845,2081.68 2636.432,1084.403 2638.915,1088.637 3224.01,2086.52  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103237953908562468880000014541959725076395907_",
    gradientUnits: "userSpaceOnUse",
    x1: 2031.4546,
    y1: 2156.4131,
    x2: 3241.3972,
    y2: 2156.4131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5554,
    style: {
      stopColor: "#6F2B60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103237953908562468880000014541959725076395907_)"
    },
    d: "M3241.397,2088.34 c0,44.394-270.855,216.529-604.971,216.529s-604.971-172.135-604.971-216.529c0-44.394,270.855-80.383,604.971-80.383 S3241.397,2043.946,3241.397,2088.34z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 2636.426,
    cy: 2084.826,
    rx: 604.971,
    ry: 80.382
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147907192930372043090000004362037664729595046_",
    gradientUnits: "userSpaceOnUse",
    x1: 2632.3335,
    y1: 2034.4655,
    x2: 2641.4033,
    y2: 2135.3647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000147907192930372043090000004362037664729595046_)"
    },
    cx: 2636.426,
    cy: 2079.992,
    rx: 585.095,
    ry: 64.365
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021117884785505222180000014627149918386298242_",
    gradientUnits: "userSpaceOnUse",
    x1: 2627.8088,
    y1: 869.2878,
    x2: 2657.9224,
    y2: 1642.1968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000021117884785505222180000014627149918386298242_)"
    },
    cx: 2636.426,
    cy: 1090.458,
    rx: 71.406,
    ry: 79.735
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106844331947055182280000005487368814974744228_",
    gradientUnits: "userSpaceOnUse",
    x1: 1948.9513,
    y1: 667.4367,
    x2: 1988.3933,
    y2: 1106.2263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106844331947055182280000005487368814974744228_)"
    },
    d: "M2015.324,517.388l-127.783-5.917 c-29.012-1.343-52.654,25.812-52.654,60.66v106.026l34.111,492.447c2.255,32.556,24.977,57.061,52.121,56.37l61.263-1.561 c26.665-0.68,48.766-25.926,50.948-58.048l32.776-482.399V581.382C2066.106,547.338,2043.436,518.69,2015.324,517.388z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066494333135269477140000011625907394076262295_",
    gradientUnits: "userSpaceOnUse",
    x1: 1975.8735,
    y1: 667.4367,
    x2: 2015.3154,
    y2: 1106.2263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066494333135269477140000011625907394076262295_)"
    },
    d: "M2042.247,517.388l-127.783-5.917 c-29.012-1.343-52.654,25.812-52.654,60.66v106.026l34.111,492.447c2.255,32.556,24.977,57.061,52.121,56.37l61.263-1.561 c26.665-0.68,48.766-25.926,50.948-58.048l32.776-482.399V581.382C2093.029,547.338,2070.358,518.69,2042.247,517.388z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2015.573,992.904c-39.419-154.341-110.443-219.11-121.731-367.604 c-3.048-40.12-1.021-77.456,3.7-111.21c-20.737,7.501-35.734,30.307-35.734,58.041v106.025l34.111,492.447 c2.256,32.555,24.978,57.06,52.12,56.369l61.264-1.562c10.396-0.265,20.077-4.301,28.176-10.986 C2041.583,1120.654,2029.298,1046.644,2015.573,992.904z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133521640962903530250000016705689426801600673_",
    gradientUnits: "userSpaceOnUse",
    x1: 1896.8032,
    y1: 1643.722,
    x2: 1805.9961,
    y2: 1973.1619
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133521640962903530250000016705689426801600673_)"
    },
    d: "M1908.958,1235.275 c0,0-227.603,91.098-188.956,337.434c38.647,246.336,377.133,169.042,377.133,169.042l19.877-169.042 c0,0-257.269,10.78-224.855-147.425c35.287-172.226,65.378-174.07,65.378-174.07L1908.958,1235.275z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059304943115273470800000016252696197062507937_",
    gradientUnits: "userSpaceOnUse",
    x1: 2153.0779,
    y1: 3052.1902,
    x2: 2175.6416,
    y2: 3458.3401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059304943115273470800000016252696197062507937_)"
    },
    d: "M2209.599,3196.611 c0,0,2.821,22.452,0.928,29.974c-1.897,7.522-67.172,12.957-89.331,10.341c-22.157-2.613,13.199-25.247,27.316-29.494 C2162.628,3203.183,2209.599,3196.611,2209.599,3196.611z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160185717467291348560000004010200833951339906_",
    gradientUnits: "userSpaceOnUse",
    x1: 2195.6921,
    y1: 3252.3469,
    x2: 2183.7056,
    y2: 2703.9822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160185717467291348560000004010200833951339906_)"
    },
    d: "M2176.739,3159.157l6.881,45.045 c0,0,17.545,7.885,25.98,0.093l0.928-47.15L2176.739,3159.157z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119101424860065734810000016737794856483327160_",
    gradientUnits: "userSpaceOnUse",
    x1: 2561.4692,
    y1: 3029.5081,
    x2: 2584.0322,
    y2: 3435.6423
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119101424860065734810000016737794856483327160_)"
    },
    d: "M2544.728,3157.145 c0,0-13.852,10.278-10.159,22.587c3.692,12.309,36.012,61.63,59.046,75.629c23.032,13.999,15.812-15.166,9.11-33.331 c-6.702-18.166-23.831-58.177-30.516-64.886C2565.523,3150.44,2544.728,3157.145,2544.728,3157.145z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054968165950821174710000017890756437188850069_",
    gradientUnits: "userSpaceOnUse",
    x1: 2555.2488,
    y1: 3244.4871,
    x2: 2543.2627,
    y2: 2696.1287
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054968165950821174710000017890756437188850069_)"
    },
    d: "M2519.813,3107.659 c6.695,18.663,13.136,34.006,18.174,45.323c11.144,25.039,17.235,34.433,24.133,42.578c6.017,7.094,20.258,22.233,24.086,19.712 c3.888-2.554-6.532-20.959-26.613-74.864c-2.918-7.821-12.13-32.75-12.13-32.75l0,0H2519.813z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067938824577046933330000013157291110077114267_",
    gradientUnits: "userSpaceOnUse",
    x1: 2021.5917,
    y1: 2895.936,
    x2: 2249.3284,
    y2: 2590.2891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067938824577046933330000013157291110077114267_)"
    },
    d: "M2040.035,2327.822 c-4.776,46.91-9.361,119.719-2.507,208.084c8.932,115.129,31.952,187.981,60.821,310.736 c17.645,75.018,41.418,185.432,62.933,323.52c4.991,2.857,19.676,10.371,38.586,7.566c10.586-1.573,18.504-5.78,23.179-8.807 c56.447-172.485,39.775-279.373,12.535-345.968c-11.61-28.387-25.689-50.781-33.214-94.416 c-9.957-57.731,2.354-90.004,19.911-223.729c12.515-95.314,10.347-110.047,2.021-124.34 C2191.019,2323.319,2089.216,2324.436,2040.035,2327.822z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124850314861672304750000000540808321684492952_",
    gradientUnits: "userSpaceOnUse",
    x1: 2190.7656,
    y1: 2933.8679,
    x2: 2724.1492,
    y2: 2436.4434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124850314861672304750000000540808321684492952_)"
    },
    d: "M2234.328,2347.882 c34.58,178.579,68.519,272.372,94.202,325.422c6.333,13.082,27.467,55.292,47.443,115.806 c17.686,53.564,25.056,92.967,28.831,110.311c11.922,54.739,41.385,134.665,120.667,239.496 c0.988,0.583,14.507,8.228,27.431,1.412c6.541-3.452,9.8-8.953,11.097-11.517c-10.366-100.227-22.264-184.449-32.59-249.449 c-2.17-13.633-11.711-73.28-26.677-152.082c-5.857-30.84-14.439-76.025-24.719-122.437 c-12.798-57.796-32.425-136.423-62.675-230.64C2356.336,2365.427,2295.331,2356.657,2234.328,2347.882z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005989421683760411400000004181010187509297824_",
    gradientUnits: "userSpaceOnUse",
    x1: 2233.7104,
    y1: 2007.0023,
    x2: 2071.0625,
    y2: 1776.5845,
    gradientTransform: "matrix(0.914 -0.4057 0.4057 0.914 -44.3241 868.3495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005989421683760411400000004181010187509297824_)"
    },
    d: "M2282.516,1592.925 c-27.529-6.918-74.801-7.997-113.426-42.141c-11.627-10.277-52.818-46.693-37.493-95.338 c9.094-28.876,36.842-58.059,69.027-66.376c27.503-7.106,38.209,6.217,95.219,17.29c22.191,4.308,57.859,11.236,92.855,8.354 c59.959-4.933,83.586-35.822,136.571-57.016c65.095-26.034,152.911-28.803,208.279-0.718 c98.271,49.844,41.284,169.954,151.562,230.498c36.132,19.832,44.403,8.119,124.226,42.128 c79.931,34.054,119.895,51.077,130.878,88.807c15.24,52.363-26.663,127.446-84.423,156.924 c-56.421,28.799-110.261,6.607-132.218,36.515c-15.631,21.283,6.697,39.28-3.115,77.173 c-12.645,48.855-65.823,81.076-74.413,86.276c-79.713,48.303-230.887,14.995-323.395-62.903 C2355.84,1871.924,2432.18,1630.54,2282.516,1592.925z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150068755080172812290000013877770799042072997_",
    gradientUnits: "userSpaceOnUse",
    x1: 2050.6416,
    y1: 2917.5813,
    x2: 2278.3782,
    y2: 2611.9348
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000150068755080172812290000013877770799042072997_)"
    },
    d: "M2235.582,2822.954 c-11.61-28.388-25.689-50.783-33.214-94.416c-9.957-57.731,2.354-90.004,19.911-223.729 c12.515-95.314,10.347-110.047,2.021-124.34c-18.087-31.057-56.417-44.838-95.534-50.466c0.522,2.005,1.05,4.015,1.475,5.957 c20.524,93.731-57.805,150.921-22.474,253.955c17.418,50.799,45.214,62.435,51.689,121.361 c6.067,55.198-15.935,66.697-11.236,116.865c7.025,74.995,60.301,93.145,74.164,150.575c9.008,37.319,1.421,91.886-64.37,170.872 c1.094,6.805,2.184,13.631,3.267,20.575c4.994,2.857,19.676,10.371,38.586,7.566c10.586-1.573,18.504-5.78,23.179-8.807 C2279.494,2996.437,2262.823,2889.549,2235.582,2822.954z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088108779115375552460000016203927727304668040_",
    gradientUnits: "userSpaceOnUse",
    x1: 2085.439,
    y1: 1883.0348,
    x2: 2591.3628,
    y2: 2547.061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088108779115375552460000016203927727304668040_)"
    },
    d: "M1967.84,1628.026 c5.176-8.039,21.63-30.314,91.458-46.732c34.998-8.227,99.701-22.323,182.967-4.679 c114.361,24.23,185.584,92.852,212.391,121.696c-21.952,14.293-82.529,57.906-112.528,140.646 c-9.334,25.742-36.909,113.748,2.528,196.177c22.723,47.5,62.921,83.157,93.449,110.246 c45.791,40.621,69.506,46.865,84.857,83.26c16.718,39.631-0.128,58.956,20.633,86.088c22.297,29.136,48.421,15.593,86.213,45.059 c38.714,30.179,24.937,55.02,60.168,88.374c51.193,48.459,119.059,32.721,122.217,54.527 c2.719,18.757-45.513,44.207-86.492,54.528c-81.151,20.44-151.935-13.868-172.983-24.444 c-58.276-29.277-48.209-48.227-92.64-70.546c-74.396-37.372-125.242,4.215-294.692,8.497 c-91.764,2.322-138.163,2.844-163.583-28.203c-23.215-28.359-11.012-59.465,2.92-193.521c0,0,0-0.005,0.001-0.016 c4.477-44.77,13.851-138.507,13.907-191.925c0.034-31.569-10.913-83.149-32.811-186.311 c-1.293-6.085-13.142-61.818-22.717-136.271C1954.482,1667.433,1955.731,1646.845,1967.84,1628.026z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180324361209892439670000006317250023685665970_",
    gradientUnits: "userSpaceOnUse",
    x1: 2392.9604,
    y1: 1569.3613,
    x2: 2523.3247,
    y2: 2366.5906
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180324361209892439670000006317250023685665970_)"
    },
    d: "M2689.977,2448.159 c-35.231-33.354-21.454-58.195-60.168-88.374c-37.793-29.467-63.917-15.923-86.213-45.059 c-20.761-27.132-3.915-46.457-20.633-86.088c-15.351-36.395-39.066-42.637-84.857-83.261 c-30.529-27.087-70.726-62.745-93.449-110.245c-39.437-82.429-11.862-170.435-2.528-196.177 c29.999-82.74,90.576-126.352,112.528-140.646c-2.113-2.278-4.606-4.871-7.272-7.602 c-144.626,19.875-228.951,103.443-239.378,128.19c-24.108,57.199,14.056,78.214,15.041,243.183 c0.469,78.853-8.035,109.988,17.548,142.902c29.261,37.64,62.981,25.992,105.293,75.208 c32.513,37.81,27.306,61.785,57.663,77.716c32.643,17.127,53.434-2.835,90.252,5.016c61.51,13.117,74.658,84.039,115.322,122.84 c30.749,29.342,87.601,49.856,199.724,27.837c2.593-3.775,3.846-7.461,3.345-10.914 C2809.032,2480.88,2741.17,2496.619,2689.977,2448.159z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043454469177124668720000000316162251215175041_",
    gradientUnits: "userSpaceOnUse",
    x1: 2247.8728,
    y1: 1398.1208,
    x2: 2121.3911,
    y2: 1770.5378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043454469177124668720000000316162251215175041_)"
    },
    d: "M2195.323,1487.215 c0,0,7.294,58.309,28.814,71.67c21.523,13.351,56.314,30.803,60.146,35.542c3.832,4.73-133.322,19.478-201.29-14.822l0,0 c22.4-4.671,28.49-6.39,28.49-6.39c6.08-1.718,17.419-4.913,28.787-11.392c7.737-4.406,20.21-13.015,31.65-29.269l-0.25-32.286 L2195.323,1487.215z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052797004468597181320000000048928645123586479_",
    gradientUnits: "userSpaceOnUse",
    x1: 2163.6428,
    y1: 1495.3203,
    x2: 2383.8894,
    y2: 1362.7228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052797004468597181320000000048928645123586479_)"
    },
    d: "M2198.596,1507.867 c0,0-14.032,19.26-36.037,11.233c-19.704-7.185-7.944-58.076,7.685-63.88c5.213-1.937,14.786-1.08,21.185,2.912 c4.501,2.807,16.519,17.737,9.63,34.469c4.978-1.443,9.359-0.134,10.456,2.332c1.394,3.127-2.822,7.384-3.776,8.35 C2204.429,1506.626,2200.437,1507.561,2198.596,1507.867z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126301940667345623330000015168312741104386692_",
    gradientUnits: "userSpaceOnUse",
    x1: 1932.1934,
    y1: 1167.4066,
    x2: 1913.4554,
    y2: 1245.8715
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126301940667345623330000015168312741104386692_)"
    },
    d: "M1945.654,1239.798l32.149-16.433 c0,0-67.925-4.269-84.321-28.863c-16.396-24.594-28.107-24.594-19.909-8.198c5.565,11.13,30.016,35.259,45.149,49.612 C1925.973,1242.793,1936.755,1244.347,1945.654,1239.798z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154387814296608442020000001318534673064960674_",
    gradientUnits: "userSpaceOnUse",
    x1: 2297.6609,
    y1: 1829.5895,
    x2: 2615.7664,
    y2: 1829.5895
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154387814296608442020000001318534673064960674_)"
    },
    d: "M2299.639,1870.195 c-14.343,30.461,51.57,101.407,124.831,135.095c14.926,6.867,122.117,56.152,169.892,8.76 c39.475-39.164,13.999-120.144,4.904-149.054c-44.664-141.962-181.824-214.176-239.306-240.221 c-42.899,107.265-17.634,155.063-7.69,169.987c10.389,15.59,39.381,48.339,70.171,77.19 c21.66,20.291,35.147,30.166,33.333,33.331c-2.258,3.94-27.645-3.501-126.255-51.499 C2318.087,1855.635,2304.542,1859.794,2299.639,1870.195z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097473521128603231240000017227645469847863217_",
    gradientUnits: "userSpaceOnUse",
    x1: 2120.8386,
    y1: 2296.3643,
    x2: 2145.8921,
    y2: 2076.4485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5554,
    style: {
      stopColor: "#6F2B60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097473521128603231240000017227645469847863217_)"
    },
    d: "M2055.763,1692.16l174.546,16.347 c3.66,0.343,6.735,2.894,7.747,6.428l65.137,227.447c1.724,6.02-3.127,11.897-9.364,11.346l-175.98-15.528 c-3.701-0.326-6.812-2.912-7.811-6.49l-63.702-228.266C2044.654,1697.417,2049.534,1691.577,2055.763,1692.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176024019919105201860000005817167807887224717_",
    gradientUnits: "userSpaceOnUse",
    x1: 2073.3313,
    y1: 2290.9509,
    x2: 2098.385,
    y2: 2071.0349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5554,
    style: {
      stopColor: "#6F2B60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000176024019919105201860000005817167807887224717_)"
    },
    d: "M2171.94,1888.89 c-6.583-35.954,13.702-63.834-5.737-97.535c-19.997-34.668-55.106-28.816-80.323-57.374c-8.027-9.09-15.231-21.97-18.77-40.758 l-11.346-1.063c-6.229-0.584-11.109,5.257-9.428,11.283l63.702,228.267c0.999,3.578,4.11,6.164,7.811,6.49l89.365,7.885 C2184.477,1925.679,2175.081,1906.039,2171.94,1888.89z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147930793212087022360000011281274362282294193_",
    gradientUnits: "userSpaceOnUse",
    x1: 2273.5461,
    y1: 1815.2552,
    x2: 2362.1431,
    y2: 2357.0613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147930793212087022360000011281274362282294193_)"
    },
    d: "M2324.545,1863.072 c0,0-60.111-61.507-84.574-70.592c-24.462-9.087-2.803,55.788,11.53,64.937c14.332,9.15,19.924,12.645,31.108,14.041 c11.182,1.399,11.182,1.399,11.182,1.399l14.679,7.826C2308.47,1880.684,2327.341,1878.449,2324.545,1863.072z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartScaleSupport);
export default __webpack_public_path__ + "static/media/smart_scale_support.f97ead2ad8b8314566f41c541727bc5a.svg";
export { ForwardRef as ReactComponent };